export const MAX_METRICS_TREE_NODE_COUNT = 30;
//# sourceMappingURL=catalogMetricsTree.js.map